import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function BrowserPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const url = searchParams.get('url');

  useEffect(() => {
    // 重定向到新的聚光浏览器
    if (url) {
      navigate(`/juguang-browser?url=${encodeURIComponent(url)}`);
    } else {
      navigate('/juguang-browser');
    }
  }, [navigate, url]);

  return null;
}

